module.exports = __webpack_public_path__ + "static/img/planPaybg1.5fc3045a.png";